import { moduleFactory } from "@/factories/module";
import { appleIdentityTriggerLogIn } from "@/modules/apple-identity/log-in";
import { appleIdentityParseOAuthResult } from "@/modules/apple-identity/parse-o-auth-result";

export const appleIdentityModule = moduleFactory.create({
  triggerLogIn: appleIdentityTriggerLogIn,
  parseOAuthResult: appleIdentityParseOAuthResult,
});
